"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./RadioButtonGroup.css");
function RadioButtonGroup(_a) {
    var name = _a.name, groupLabel = _a.label, Icon = _a.labelIcon, groupValue = _a.value, options = _a.options, onChange = _a.onChange;
    var handleChange = React.useCallback(function (_a) {
        var target = _a.target;
        onChange === null || onChange === void 0 ? void 0 : onChange({ name: target.name, value: target.value });
    }, [onChange]);
    var memorizedLabel = React.useMemo(function () {
        return groupLabel && (React.createElement("div", { className: "nimbus--radio-button-group__label" },
            Icon && (React.createElement("div", { className: "nimbus--radio-button-group__label-icon" },
                React.createElement(Icon, null))),
            groupLabel));
    }, [groupLabel, Icon]);
    return (React.createElement("div", { className: "nimbus--radio-button-group-wrapper" },
        memorizedLabel,
        React.createElement("div", { className: "nimbus--radio-button-group" }, options.map(function (_a) {
            var label = _a.label, value = _a.value, _b = _a.disabled, disabled = _b === void 0 ? false : _b;
            return (React.createElement("div", { key: "key_".concat(name, "_").concat(value), className: "nimbus--radio-button-wrapper" },
                React.createElement("input", { type: "radio", id: "radio_".concat(name, "_").concat(value), name: name, value: value, className: "nimbus--radio-button", checked: groupValue === value, disabled: disabled, onChange: handleChange, tabIndex: 0 }),
                React.createElement("label", { htmlFor: "radio_".concat(name, "_").concat(value), className: "nimbus--radio-button-label" }, label)));
        }))));
}
exports.default = RadioButtonGroup;
//# sourceMappingURL=index.js.map